<template>
  <transition name="global" @leave="leave" appear @enter="enter">
    <div class="content">
      <div ref="cursor" class="arrow-cursor">
        <svg class="arrow-cursor__icon" viewBox="0 0 117.25 86.75">
          <path
            class="arrow-cursor__path"
            d="M111.45,42.5,74.65,5.7l-9.9,9.9,20.6,20.6H6.45v14h78.9L64.75,70.8l9.9,9.9,36.8-36.8A1,1,0,0,0,111.45,42.5Z"
          />
        </svg>
      </div>
      <section class="grid">
        <div class="swiper-container image-swiper">
          <div class="swiper-wrapper" ref="mySwiper">
            <div ref="projet01" class="swiper-slide projet01">
              <router-link to="/sachassou">
                <div
                  class="swiper-slide__img-wrap"
                  @mouseenter="zoom($event.target)"
                  @mouseleave="reverseZoom($event.target, 'over')"
                  @click="reverseZoom($event.target, 'click')"
                >
                  <div
                    class="item__img"
                    style="background-image: url(../../static/images/projets/sachassou.jpg)"
                  >
                    <img
                      src="../../static/images/projets/sachassou.jpg"
                      style="opacity: 0; width: 100%"
                      alt="Image de Sachassou"
                    />
                  </div>
                </div>
                <div class="title-container">
                  <h3>Sachassou</h3>
                </div>
              </router-link>
            </div>
            <div class="swiper-slide projet02">
              <router-link to="/datavisualisation">
                <div
                  class="swiper-slide__img-wrap"
                  @mouseenter="zoom($event.target)"
                  @mouseleave="reverseZoom($event.target)"
                  @click="reverseZoom($event.target)"
                >
                  <div
                    class="item__img"
                    style="background-image: url(../../static/images/projets/dataviz.jpg)"
                  >
                    <img
                      src="../../static/images/projets/dataviz.jpg"
                      style="opacity: 0; width: 100%"
                      alt="Image de la Datavisualisation"
                    />
                  </div>
                </div>
                <div class="title-container">
                  <h3>Datavisualisation</h3>
                </div>
              </router-link>
            </div>

            <div class="swiper-slide projet03">
              <router-link to="/belfort-by-night">
                <div
                  class="swiper-slide__img-wrap"
                  @mouseenter="zoom($event.target)"
                  @mouseleave="reverseZoom($event.target)"
                  @click="reverseZoom($event.target)"
                >
                  <div
                    class="item__img"
                    style="background-image: url(../../static/images/projets/illustration-svg.jpg)"
                  >
                    <img
                      src="../../static/images/projets/illustration-svg.jpg"
                      style="opacity: 0; width: 100%"
                      alt="Aperçu de l'illustration en SVG"
                    />
                  </div>
                </div>
                <div class="title-container">
                  <h3>Belfort by night</h3>
                </div>
              </router-link>
            </div>

            <div ref="projet04" class="swiper-slide projet04">
              <router-link to="/asso-lard">
                <div
                  class="swiper-slide__img-wrap"
                  @mouseenter="zoom($event.target)"
                  @mouseleave="reverseZoom($event.target)"
                  @click="reverseZoom($event.target)"
                >
                  <div
                    class="item__img"
                    style="background-image: url(../../static/images/projets/asso-lard.jpg)"
                  >
                    <img
                      src="../../static/images/projets/asso-lard.jpg"
                      style="opacity: 0; width: 100%"
                      alt="Image de l'association des LARD"
                    />
                  </div>
                </div>
                <div class="title-container">
                  <h3>L.A.R.D.</h3>
                </div>
              </router-link>
            </div>
          </div>
          <div class="button button-next"></div>
          <div style="display: none" class="button button-prev"></div>
        </div>
        <div class="mobile-project">
          <ul>
            <li>
              <router-link to="/sachassou">Sachassou</router-link>
            </li>
            <li>
              <router-link to="/datavisualisation">Datavisualisation</router-link>
            </li>
            <li>
              <router-link to="/belfort-by-night">Belfort by night</router-link>
            </li>
            <li>
              <router-link to="/asso-lard">L.A.R.D.</router-link>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
//import TweenMax from "gsap/TweenMax";
export default {
  name: "Projets",
  data() {
    return {
      //{ Back }: window,
      clientX: 0,
      clientY: 0,
      gallery: {},
      swiper: "",
      buttonNext: null,
      buttonPrev: null,
      activeSlide: null,
      prevSlide: null,
      nextSlide: null,
      title: null,
      activeTitle: null,
      prevTitle: null,
      nextTitle: null,
      isEnterFinished: false,
      imageToZoom: null,
      isFirstSlide: true,
      isLastSlide: false
    };
  },
  methods: {
    initSwiper() {
      var gallery = new Swiper(".image-swiper", {
        spaceBetween: 200,
        slidesPerView: "auto",
        loop: false,
        centeredSlides: true,
        loopedSlides: 10, //looped slides should be the same
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev"
        },
        shortSwipes: false

        //mousewheel: true
      });
      this.gallery = gallery;

      this.activeSlide = document.querySelector(
        ".image-swiper .swiper-slide-active"
      );
      this.prevSlide = document.querySelector(
        ".image-swiper .swiper-slide-prev"
      );
      this.nextSlide = document.querySelector(
        ".image-swiper .swiper-slide-next"
      );

      this.gallery.on("transitionStart", this.slideChangeTransitionStart);
      this.gallery.on("transitionEnd", this.slideChangeTransitionEnd);
      var cursor = document.querySelector(".arrow-cursor");
      var easing = "back.out(1.7)";
      this.activeSlide.querySelector(".title-container").style.opacity = 1;
      this.gallery.on("slideChange", () => {
        TweenMax.to(cursor, 0.1, {
          scale: 0.85,

          onComplete: () => {
            TweenMax.to(cursor, 0.2, {
              scale: 1,
              ease: easing
            });
          }
        });
        /*  console.log(this.nextSlide);
        
        var currentTitle = this.nextSlide.querySelector(".title-container");
        TweenMax.set(currentTitle, {
          opacity: 0,
          x: '-40px',
        
        });
        TweenMax.to(currentTitle, 1, {
          delay: 0.2,
          opacity: 1,
          x:0,
          ease: "power2.out"
        });
        var lastTitle = this.activeSlide.querySelector(".title-container");
        TweenMax.to(lastTitle, 0.5, {
          opacity: 0,
          x: '-40px',
        
        });*/
      });
    },
    initCursor() {
      var _window = window;
      var globalCursor = document.querySelector(".cursor");
      var cursor = document.querySelector(".arrow-cursor");
      var cursorIcon = document.querySelector(".arrow-cursor__icon");
      var cursorBox = cursor.getBoundingClientRect();
      var easing = "back.out(1.7)";
      var animationDuration = 0.3;
      var cursorSide = null;
      var cursorInsideSwiper = false;
      var swiperBox;
      var side;

      TweenMax.to(cursorIcon, 0, {
        rotation: -135,
        opacity: 0,
        scale: 0.5
      });
      var clientX, clientY;
      document.addEventListener("mousemove", function(e) {
        clientX = e.clientX;
        clientY = e.clientY;
        side = e.clientX < window.innerWidth / 2 ? "left" : "right";
      });

      var render = function render() {
        TweenMax.set(cursor, {
          x: clientX,
          y: clientY
        });
        requestAnimationFrame(render);
      };

      requestAnimationFrame(render); // mouseenter

      var onSwiperMouseEnter = function onSwiperMouseEnter(e) {
        swiperBox = e.target.getBoundingClientRect();
        if (!window.clientX) window.clientX = e.clientX;
        if (!window.clientY) window.clientY = e.clientY;
        var startRotation;

        if (window.clientY < swiperBox.top + swiperBox.height / 2) {
          startRotation = -135;
        } else {
          startRotation = window.clientX > window.innerWidth / 2 ? 135 : -315;
        }

        TweenMax.set(cursorIcon, {
          rotation: startRotation
        });
        cursorSide = window.clientX > window.innerWidth / 2 ? "right" : "left";
        TweenMax.to(cursorIcon, animationDuration, {
          rotation: side === "right" ? 0 : -180,
          scale: 1,
          opacity: 1,
          ease: easing
        });

        globalCursor.setAttribute("style", "opacity: 0");
      }; // mouseLeave

      var onSwiperMouseLeave = function onSwiperMouseLeave(e) {
        swiperBox = e.target.getBoundingClientRect();
        var outRotation = 0;

        if (window.clientY < swiperBox.top + swiperBox.height / 2) {
          outRotation = side === "right" ? -135 : -45;
        } else {
          outRotation = side === "right" ? 135 : -315;
        }

        TweenMax.to(cursorIcon, animationDuration, {
          rotation: outRotation,
          opacity: 0,
          scale: 0.3
        });
        cursorSide = null;
        cursorInsideSwiper = false;

        globalCursor.setAttribute("style", "opacity: 1");
      }; // move cursor from left to right or right to left inside the Swiper

      var onSwitchSwiperSides = function onSwitchSwiperSides() {
        if (cursorInsideSwiper) {
          TweenMax.to(cursorIcon, animationDuration, {
            rotation: side === "right" ? 180 : 0,
            ease: easing
          });
          //side = side === "left" ? "right" : "left";
        }

        if (!cursorInsideSwiper) {
          cursorInsideSwiper = true;
        }

        /*if(cursorSide = 'right') {
          var nextSlide = document.querySelector('.swiper-slide-next .swiper-slide__img-wrap');
          TweenMax.to(nextSlide, animationDuration, {
            scaleX : 1.2,
            scaleY : 1.2,
            ease: easing
          });
        }*/
      };

      var swiperButtonPrev = document.querySelector(".button-prev");
      var swiperButtonNext = document.querySelector(".button-next");
      this.buttonNext = swiperButtonNext;
      this.buttonPrev = swiperButtonPrev;
      swiperButtonNext.addEventListener("mouseenter", onSwiperMouseEnter);
      swiperButtonNext.addEventListener("mouseleave", onSwiperMouseLeave);
      swiperButtonNext.addEventListener("mouseenter", onSwitchSwiperSides);
      this.gallery.on("transitionEnd", () => {
        if (this.isFirstSlide == false) {
          swiperButtonPrev.style.display = "block";
          swiperButtonPrev.addEventListener("mouseenter", onSwiperMouseEnter);
          swiperButtonPrev.addEventListener("mouseleave", onSwiperMouseLeave);
          swiperButtonPrev.addEventListener("mouseenter", onSwitchSwiperSides);
        } else {
          swiperButtonPrev.style.display = "none";
        }
        if (this.isLastSlide == false) {
          swiperButtonNext.style.display = "block";
          swiperButtonNext.addEventListener("mouseenter", onSwiperMouseEnter);
          swiperButtonNext.addEventListener("mouseleave", onSwiperMouseLeave);
          swiperButtonNext.addEventListener("mouseenter", onSwitchSwiperSides);
        } else {
          swiperButtonNext.style.display = "none";
        }
      });
    },
    zoom(el) {
      var imageToZoom = el.children[0];
      this.imageToZoom = imageToZoom;

      TweenMax.set(imageToZoom, {
        filter: "brightness(100%)"
      });
      TweenMax.to(imageToZoom, 1, {
        scale: 1.2,
        filter: "brightness(50%)",
        ease: "power2.out"
      });

      var currentTitle = el.offsetParent.children[0].children[1];
      //this.activeSlide.querySelector(".title-container");

      TweenMax.to(currentTitle, 1, {
        y: -5 + "vw",
        ease: "power2.out"
      });
      var cursorCircle = document.querySelector(".cursor__inner--circle");

      cursorCircle.classList.add("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 60 + "px",
        height: 60 + "px",
        top: -20 + "px",
        left: -20 + "px",
        ease: "back.out(1.7)"
      });
    },
    reverseZoom(el, clickOrOver) {
      var imageToZoom = el.children[0];

      TweenMax.to(imageToZoom, 1, {
        scale: 1,
        filter: "brightness(100%)",
        ease: "power2.out"
      });

      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.remove("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 20,
        height: 20,
        top: 0,
        left: 0,
        ease: "back.out(1.7)"
      });

      var currentTitle = this.activeSlide.querySelector(".title-container");

      TweenMax.to(currentTitle, 1, {
        y: 0,

        ease: "power2.out"
      });
    },
    slideChangeTransitionStart() {
      let $wrapperEl = this.gallery.$wrapperEl;
      let params = this.gallery.params;
      $wrapperEl
        .children("." + params.slideClass + "." + params.slideDuplicateClass)
        .each(function() {
          let idx = this.getAttribute("data-swiper-slide-index");
          this.innerHTML = $wrapperEl
            .children(
              "." +
                params.slideClass +
                '[data-swiper-slide-index="' +
                idx +
                '"]:not(.' +
                params.slideDuplicateClass +
                ")"
            )
            .html();
        });
    },
    slideChangeTransitionEnd() {
      this.gallery.slideToLoop(this.gallery.realIndex, 0, false);
      this.activeSlide = document.querySelector(
        ".image-swiper .swiper-slide-active"
      );
      this.prevSlide = document.querySelector(
        ".image-swiper .swiper-slide-prev"
      );
      this.nextSlide = document.querySelector(
        ".image-swiper .swiper-slide-next"
      );

      if (this.activeSlide !== this.$refs.projet01) {
        this.isFirstSlide = false;
      } else {
        this.isFirstSlide = true;
      }

      if (this.activeSlide !== this.$refs.projet04) {
        this.isLastSlide = false;
      } else {
        this.isLastSlide = true;
      }
    },
    mouseOverNextButton() {
      this.buttonNext.addEventListener("mouseenter", nextAnimation);
      this.buttonNext.addEventListener("mouseleave", nextAnimationReverse);
      this.buttonNext.addEventListener("click", nextAnimationReverse);
      var self = this;

      function nextAnimation() {
        if (self.prevSlide) {
          TweenMax.set(self.prevSlide, {
            filter: "brightness(100%)",
            x: 0
          });
          TweenMax.to(self.prevSlide, 0.8, {
            delay: 0.2,
            x: -100 + "px",
            filter: "brightness(50%)",
            ease: "power3.out"
          });
        }

        if (self.nextSlide) {
          TweenMax.to(self.nextSlide, 0.8, {
            scale: 1.2,
            ease: "power3.out"
          });
        }

        TweenMax.set(self.activeSlide, {
          filter: "brightness(100%)",
          x: 0
        });
        TweenMax.to([self.activeSlide, ".title-swiper"], 0.8, {
          delay: 0.1,
          x: -100 + "px",
          filter: "brightness(50%)",
          ease: "power3.out"
        });
      }

      function nextAnimationReverse() {
        if (self.prevSlide) {
          TweenMax.to(self.prevSlide, 0.8, {
            delay: 0.2,
            x: 0,
            filter: "brightness(100%)",
            ease: "power3.out"
          });
        }

        if (self.nextSlide) {
          TweenMax.to(self.nextSlide, 0.8, {
            scale: 1,
            ease: "power3.out"
          });
        }

        TweenMax.to([self.activeSlide, ".title-swiper"], 0.8, {
          delay: 0.1,
          x: 0,
          filter: "brightness(100%)",
          ease: "power3.out"
        });
      }
    },
    mouseOverPrevButton() {
      this.buttonPrev.addEventListener("mouseenter", prevAnimation);
      this.buttonPrev.addEventListener("mouseleave", prevAnimationReverse);
      this.buttonPrev.addEventListener("click", prevAnimationReverse);
      var self = this;

      function prevAnimation() {
        TweenMax.set(self.activeSlide, {
          filter: "brightness(100%)",
          x: 0
        });
        TweenMax.set(self.nextSlide, {
          filter: "brightness(100%)",
          x: 0
        });
        TweenMax.to(self.prevSlide, 0.8, {
          scale: 1.2,
          ease: "power3.out"
        });
        TweenMax.to([self.activeSlide, ".title-swiper"], 0.8, {
          delay: 0.1,
          x: 100 + "px",
          filter: "brightness(50%)",
          ease: "power3.out"
        });
        TweenMax.to(self.nextSlide, 0.8, {
          delay: 0.2,
          x: 100 + "px",
          filter: "brightness(50%)",
          ease: "power3.out"
        });
      }
      function prevAnimationReverse() {
        TweenMax.to(self.prevSlide, 0.8, {
          scale: 1,
          ease: "power3.out"
        });
        TweenMax.to([self.activeSlide, ".title-swiper"], 0.8, {
          delay: 0.1,
          x: 0,
          filter: "brightness(100%)",
          ease: "power3.out"
        });
        TweenMax.to(self.nextSlide, 0.8, {
          delay: 0.2,
          x: 0,
          filter: "brightness(100%)",
          ease: "power3.out"
        });
      }
    },
    enter(el, done) {
      var width = window.innerWidth;
      if (width > 980) {
        var gallery = new Swiper(".image-swiper", {
          spaceBetween: 200,
          slidesPerView: "auto",
          loop: false,
          centeredSlides: true,
          loopedSlides: 10, //looped slides should be the same
          navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev"
          },
          shortSwipes: false

          //mousewheel: true
        });
        this.gallery = gallery;

        var current = el.querySelector(".swiper-slide.projet01");
        var next = el.querySelector(".swiper-slide.projet02");
        //    var prev = el.querySelector(".swiper-slide-duplicate.projet04");
        //console.log(prev);

        var title = el
          .querySelector(".swiper-slide.projet01")
          .querySelector(".title-container");

        TweenMax.set(next, {
          x: "500px"
          //transformOrigin: '50% 50%'
        });
        TweenMax.to(next, 2, {
          x: 0,
          delay: 2,
          ease: Power4.easeOut,
          onComplete: done
        });
        TweenMax.set(current.querySelector(".swiper-slide__img-wrap"), {
          width: 0
          //transformOrigin: '50% 50%'
        });
        TweenMax.to(current.querySelector(".swiper-slide__img-wrap"), 1, {
          delay: 1.5,
          width: "100%",
          ease: Power2.easeOut,
          onComplete: done
        });
        TweenMax.set(title, {
          y: "100px",
          opacity: "0%",
          autoAlpha: 0
          //transformOrigin: '50% 50%'
        });
        TweenMax.to(title, 1, {
          delay: 3,
          opacity: "100%",
          autoAlpha: 1,
          y: 0,
          ease: Power2.easeOut,
          onComplete: done
        });
      } else {
        

        var liste = document.querySelector(".mobile-project ul");
        TweenMax.set(liste, {
          opacity: 0,
          y: "50px"
        });
        TweenMax.to(liste, 0.7, {
          delay: 1.5,
          opacity: 1,
          y: 0,
          ease: Power4.easeOut,
          onComplete: done
        });
      }
    },
    leave(el, done) {
      var width = window.innerWidth;
      if (width > 980) {
        var current = el.querySelector(".swiper-slide-active");
        var next = el.querySelector(".swiper-slide-next");
        var prev = el.querySelector(".swiper-slide-prev");
        var title = current.querySelector(".title-container");

        //Empêche de swipe
        this.buttonNext.style.display = "none";
        this.buttonPrev.style.display = "none";
        this.gallery.params.noSwipingClass = "swiper-slide";
        this.gallery.params.noSwiping = true;

        // current.setAttribute('style','pointer-events: none');

        TweenMax.to(prev, 2, {
          delay: 0.2,
          x: "-500px",
          ease: Power4.easeOut
        });
        TweenMax.set(next, {
          x: 0,
          ease: Power4.easeOut
        });
        TweenMax.to(next, 2, {
          delay: 0.2,
          x: "500px",
          ease: Power4.easeOut
        });

        TweenMax.to(current.querySelector(".swiper-slide__img-wrap"), 1.2, {
          delay: 0.2,
          scale: 0.7,
          ease: "back.inOut(2)"
        });
        TweenMax.to(current.querySelector(".item__img"), 1.2, {
          delay: 0.2,
          scale: 1,
          //   filter: "brightness(0.5)",
          ease: "back.inOut(2)"
        });
        TweenMax.to(current.querySelector(".swiper-slide__img-wrap"), 0.5, {
          delay: 1,
          opacity: 0,
          onComplete: done
        });

        TweenMax.to(title, 1, {
          delay: 0.1,
          opacity: 0,
          ease: Power4.easeOut
        });
      } else {
        var liste = document.querySelector(".mobile-project ul");
        TweenMax.to(liste, 0.7, {
          delay: 0.1,
          opacity: 0,
          y: "50px",
          ease: Power4.easeOut,
          onComplete: done
        });
      }
    }
  },
  mounted() {
    var width = window.innerWidth;
    if (width > 980) {
      this.initSwiper();
      this.initCursor();
      this.mouseOverNextButton();
      this.mouseOverPrevButton();
    }
    // this.enterAnimation();
  }
};
</script>

<style lang='scss'>
@import "../assets/css/projets.scss";
</style>


// WEBPACK FOOTER //
// src/components/Projets.vue